import type { Metadata } from "next";
import ImportInfluencer from "@/Component/Admin/ImportInfluencer";

export const metadata: Metadata = {
    title: "Import Influencer | Connector Club",
    description: "",
};

const ImportInfluencerPage = () => {
    return (
        <ImportInfluencer />
    );
}

export default ImportInfluencerPage;
